import { Nature, Section } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import DelaiPaiementPanel from '../panel/DelaiPaiementPanel';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';
import CovidPanel from '../panel/CovidPanel';
import FctvaPanel from '../panel/FctvaPanel';
import InformationsChorusProPanel from '../panel/InformationsChorusProPanel';
import ProjetPanel from '../panel/ProjetPanel';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';

class ProfilEcritureMarcheInvSansInventDepense extends BaseProfilEcritureDepense {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.DEPENSE.MARCHE_INV_SANS_INVENT;
    this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.DEPENSE.INVESTISSEMENT;
    this.typePiece = TYPE_PIECE.DEPENSE.MARCHE;
    this.imputation.nature = Nature.REEL;
    this.imputation.section = Section.INVESTISSEMENT;
    this.modeDeReglement = [
      MODE_REGLEMENT.DEPENSE.NUMERAIRE,
      MODE_REGLEMENT.DEPENSE.CHEQUE,
      MODE_REGLEMENT.DEPENSE.VIREMENT,
      MODE_REGLEMENT.DEPENSE.VIREMENT_GROS_MT,
      MODE_REGLEMENT.DEPENSE.OPERATION_BUD_RATT,
      MODE_REGLEMENT.DEPENSE.AVIS_DE_REGL,
    ];
    this.panels = [
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new DelaiPaiementPanel(true),
      new FctvaPanel(),
      new InformationsChorusProPanel(),
      new ProjetPanel(),
      // TODO : add "Marche public" mandatory panel
      // TODO : add "Nomenclature" optional panel
    ];
  }
}

export default ProfilEcritureMarcheInvSansInventDepense;
